import React, { useRef } from "react";
import { Button } from "@chakra-ui/react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";
import Tooltip from "rc-tooltip";
import useClickOutside from "@/js/utils/outsideClickUtils";
import { ChakraFAIcon } from "@/components/ui/Icon";

interface ConfirmScreenshotPopupProps {
	tooltipOpen: boolean;
	children: React.ReactNode;
	document: unknown;
	filename: string;
	onAccept: () => void;
	onPopupVisibleChange: (visible: boolean) => void;
}

const ConfirmScreenshotPopup = ({
	document,
	tooltipOpen,
	filename,
	onAccept,
	children,
	onPopupVisibleChange,
}: ConfirmScreenshotPopupProps): JSX.Element => {
	const { t } = useTranslation();
	const tooltipRef = useRef(null);
	const childRef = useRef(null);

	// handle clicks outside of the tooltip / children of the popup (i.e. the screenshot button)
	useClickOutside([tooltipRef, childRef], () => {
		onPopupVisibleChange(false);
	});

	const acceptButtonPressed = () => {
		onPopupVisibleChange(false);
		onAccept();
	};

	return (
		<Tooltip
			id="download-screenshot-confirmation"
			visible={tooltipOpen}
			placement="top"
			overlayClassName={"P2PDisplayModal_downloadScreenshotPopup"}
			align={{ offset: [0, -16] }}
			arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
			overlay={
				<div ref={tooltipRef}>
					<span className="P2PDisplayModal_downloadScreenshotAcceptText">{t("p2pDisplay.downloadPrivacyNotice")}</span>
					<br />
					{!!document && (
						// @ts-expect-error - Leaving as it is for now
						<PDFDownloadLink document={document} fileName={filename}>
							<Button onClick={acceptButtonPressed} gap={2} mt={4}>
								<ChakraFAIcon icon={"fa-download"} variant="solid" />
								{t("p2pDisplay.acceptAndDownload")}
							</Button>
						</PDFDownloadLink>
					)}
				</div>
			}
		>
			<div ref={childRef}>{children}</div>
		</Tooltip>
	);
};

export default ConfirmScreenshotPopup;
